import _ from 'lodash';

const Config = {};

// 自选市场(默认显示全部),如果只显示eth/btt、eos/btt，则Markets数组只用保留这2个值即可，注意Market不能为空，至少要有一个市场
Config.Markets = ['eth/btt', 'eos/btt', 'trx/btt', 'snt/btt', 'ven/btt', 'icx/btt', 'iost/btt', 'omg/btt', 'elf/btt', 'tnb/btt', 'adx/btt', 'wings/btt', 'mtl/btt', 'wtc/btt', 'dgd/btt', 'zrx/btt', 'storj/btt', 'eng/btt', 'bnt/btt', 'cmt/btt', 'eos/eth', 'omg/eth', 'kcash/eth', 'omg/eth', 'iost/eth', 'zil/eth', 'ven/eth', 'icx/eth', 'adx/eth', 'tnb/eth', 'elf/eth', 'zrx/eth', 'theta/eth', 'mana/eth', 'appc/eth', 'blz/eth', 'mco/eth', 'cmt/eth', 'dgd/eth'];
// 网站名，显示到网页title和网站内
// Icon地址，网站标题左侧的icon图标，规格16x16，格式ico

// Logo地址，规格建议129x23
// Support邮箱

// CDN路径，如为空则不使用CDN加速，否则请挂自己的cdn地址，如cdn.xxx.cn,将打包后的build中的static上传到此目录


if (process.env.NODE_RUN_ENV === 'TEST') {
    Config.EthURL = '//rinkeby.etherscan.io';
    Config.CMTURL = '//testnet.cmttracking.io';
} else {
    Config.EthURL = '//etherscan.io';
    Config.CMTURL = '//www.cmttracking.io';
}
if (process.env.NODE_RUN_ENV === 'TEST') {
    Config.BlockURL = '//explorer_test.bytetrade.com';
} else {
    Config.BlockURL = '//explorer.bytetrade.com';
}
// 支持的服务器节点,需要开放几个配置几个即可，各节点代表的地区如下：
// c1:东京(日本)，c2:佛吉尼亚(美国东海岸)，c3:伦敦(英国)，c4:'新加坡，c5:悉尼(澳大利亚),c6:圣保罗(巴西)，
// c7:加利福尼亚(美国西海岸),c8:首尔(韩国)，c9:法兰克福(德国),c10:俄亥俄州(美国东海岸)，c11:俄勒冈(美国西海岸)
if (process.env.NODE_RUN_ENV === 'TEST') {
    Config.ServerNode = ['c1', 'c2', 'c3', 'c4', 'c5', 'c6', 'c7', 'c8', 'c9', 'c10', 'c11'];
    Config.ServerPrefix = 'api_test';
}
if (process.env.NODE_RUN_ENV === 'PRODUCTION') {
    Config.ServerNode = ['p1', 'p2', 'p3', 'p4', 'p5', 'p6', 'p7', 'p8', 'p9', 'p10', 'p11'];
    Config.ServerPrefix = 'api';
}


const configFile = typeof (process.env.CONFIG) == 'string' ? JSON.parse(process.env.CONFIG) : process.env.CONFIG;
export default _.merge({
    ProjectName: 'bittrade',
}, Config, configFile);



// WEBPACK FOOTER //
// ./src/utils/Config.js